import type { TextTarget } from "../components/WorkflowTextDialog";
import type { WorkflowDetail, WorkflowStep } from "../types";

/** The dialog content for one step of a workflow. */
export const stepTarget = (detail: WorkflowDetail, step: WorkflowStep): TextTarget => ({
  title: step.label,
  description: [`Step ${step.number} of the ${detail.label} workflow.`, step.note]
    .filter(Boolean)
    .join(" "),
  source: step.source,
  markdown: step.markdown,
  planned: step.planned,
  archived: step.archived,
});
